const TREE = [

    //Sonntag
    [
        
    ],

    //Montag
    [
        {
            time: "08:00-09:00",
            title: "",
            size:10,
        },
        {
            time: "09:00-10:00",
            title: "",
            size:10,
        },
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        },
        {
            time: "14:00-15:00",
            title: "",
            size:10,
        },
        {
            time: "15:00-16:00",
            title: "",
            size:10,
        },
        {
            time: "16:00-17:00",
            title: "",
            size:10,
        },
        {
            time: "17:00-18:00",
            title: "",
            size:10,
        },
        {
            time: "18:00-19:00",
            title: "",
            size:10,
        }

       
    ],

    //Dienstag
    [
        {
            time: "08:00-09:00",
            title: "",
            size:10,
        },
        {
            time: "09:00-10:00",
            title: "",
            size:10,
        },
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        },
        {
            time: "14:00-15:00",
            title: "",
            size:10,
        },
        {
            time: "15:00-16:00",
            title: "",
            size:10,
        },
        {
            time: "16:00-17:00",
            title: "",
            size:10,
        },
        {
            time: "17:00-18:00",
            title: "",
            size:10,
        },
        {
            time: "18:00-19:00",
            title: "",
            size:10,
        }
   
       
    ],


    //Mittwoch
    [
        {
            time: "08:00-09:00",
            title: "",
            size:10,
        },
        {
            time: "09:00-10:00",
            title: "",
            size:10,
        },
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        },
        {
            time: "14:00-15:00",
            title: "",
            size:10,
        },
        {
            time: "15:00-16:00",
            title: "",
            size:10,
        },
        {
            time: "16:00-17:00",
            title: "",
            size:10,
        },
        {
            time: "17:00-18:00",
            title: "",
            size:10,
        },
        {
            time: "18:00-19:00",
            title: "",
            size:10,
        }

       
    ],


      //Donnerstag
      [
        {
            time: "08:00-09:00",
            title: "",
            size:10,
        },
        {
            time: "09:00-10:00",
            title: "",
            size:10,
        },
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        },
        {
            time: "14:00-15:00",
            title: "",
            size:10,
        },
        {
            time: "15:00-16:00",
            title: "",
            size:10,
        },
        {
            time: "16:00-17:00",
            title: "",
            size:10,
        },
        {
            time: "17:00-18:00",
            title: "",
            size:10,
        },
        {
            time: "18:00-19:00",
            title: "",
            size:10,
        }

       
    ],

    //Freitag
    [

        {
            time: "08:00-09:00",
            title: "",
            size:10,
        },
        {
            time: "09:00-10:00",
            title: "",
            size:10,
        },
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        }
        
    ],

    //Samstag
    [
        {
            time: "10:00-11:00",
            title: "",
            size:10,
            
        },
        {
            time: "11:00-12:00",
            title: "",
            size:10,
            
        },
        {
            time: "12:00-13:00",
            title: "",
            size:10,
        }
    ],

];

const DAYS = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
];


export {TREE, DAYS};